/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lineInfo: NonNullable<unknown>, totalChars: NonNullable<unknown> }} Event_Metrics_Chars_TitleInputs */

const en_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Total Characters`)
};

const fr_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caracteres totaux`)
};

const de_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Gesamtzeichen`)
};

const it_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caratteri totali`)
};

const ru_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Всего символов`)
};

const es_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caracteres totales`)
};

const zh_cn2_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} 总字符数`)
};

const ja_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} 合計文字数`)
};

const hi_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} कुल अक्षर`)
};

const pt_pt2_event_metrics_chars_title = /** @type {(inputs: Event_Metrics_Chars_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Total de caracteres`)
};

/**
* | output |
* | --- |
* | "{lineInfo} = {totalChars} Total Characters" |
*
* @param {Event_Metrics_Chars_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_chars_title = /** @type {((inputs: Event_Metrics_Chars_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Chars_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_chars_title(inputs)
	if (locale === "de") return de_event_metrics_chars_title(inputs)
	if (locale === "it") return it_event_metrics_chars_title(inputs)
	if (locale === "ru") return ru_event_metrics_chars_title(inputs)
	if (locale === "es") return es_event_metrics_chars_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_chars_title(inputs)
	if (locale === "ja") return ja_event_metrics_chars_title(inputs)
	if (locale === "hi") return hi_event_metrics_chars_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_chars_title(inputs)
	return en_event_metrics_chars_title(inputs)
});